<template>
  <page-title pageTitle="Customer Price Group" title="Add By Product Group" />
  <customer-product-group-item-form
    :priceGroup="{}"
    action-type="new"
    :submitFunction="addCustomersProductGroupItems"
    :disabled-list="new Set(['barcode', 'costPrice', 'retailPrice'])"
  />
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import CustomerProductGroupItemForm from "@/components/priceGroup/CustomerProductGroupItemForm";

export default {
  name: "AddCustomerProductGroupView",
  components: {
    CustomerProductGroupItemForm,
    PageTitle: PageTitleComponent,
  },
  data() {
    return {
      id: -1,
      priceGroup: null,
    };
  },
  computed: {
    error() {
      return this.$store.getters.billersError;
    },
    loading() {
      return this.$store.getters.billersLoading;
    },
    priceGroupName() {
      if (this.$store.getters.getPriceGroupByID(this.id)) {
        return this.$store.getters.getPriceGroupByID(this.id).name;
      }
      return "Customer Price Group";
    },
  },
  methods: {
    async addCustomersProductGroupItems(productGroup) {
      await this.$store.dispatch("addCustomersProductGroupItems", productGroup);
      this.$router.push(`/priceGroups/${productGroup.priceGroupID}`);
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    let filter = {
      resultsPerPage: 1,
    };
    await this.$store.dispatch("getPriceGroups", filter);
  },
};
</script>

<style scoped></style>
